import { AttendanceState } from '@graphql/generated';
import type { EventFormAnswer } from './types';

export const answersToFormState = (answers: EventFormAnswer[]) => {
  const formValues = answers.reduce((acc, answer) => {
    if (answer.questionValue?.field) {
      acc[answer.questionValue.field.id] = answer.answerValue;
    }
    return acc;
  }, {} as Record<string, string>);

  return { formValues };
};

export const formStateToAnswers = (formValues: Record<string, string>, attendance: boolean | null) => {
  const answers = Object.entries(formValues).map(([fieldId, answerValue]) => ({
    questionId: fieldId,
    answerValue,
  }));

  if (attendance !== null) {
    answers.push({
      questionId: 'attendanceState',
      answerValue: attendance ? AttendanceState.ATTENDING : AttendanceState.NOT_ATTENDING,
    });
  }

  return answers;
};
